import React from "react";
import { Card, Button, Stack, Container, Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types'
import svgimg from '../Assets/Sound-Wave.svg'
import { useNavigate } from "react-router-dom";


import './detailcard.css'
import Wavesample from "../waveform";
function Detailcard({imagesrc, title, disc}) {
    
  const navigate = useNavigate();
  return (
    <Container className="Contentcard">
      <Row>
        <Col lg={5} md={6} sm={6} xs={6}>
          <img className="imgcard" src={imagesrc} />
        </Col>
        <Col lg={7} md={6} sm={6} xs={6} className="gapping">
          <h4>{title}</h4>
          <h5>Last Update</h5>
          <h5>Keywords</h5>
          <h5>No. of Views:</h5>
        </Col>
      </Row>
      {/* <Row>
        <Col>{disc}
        <img src={svgimg} />
        </Col>

      </Row> */}
      {/* <Row>
        <Col></Col>
        <Col>
          <Button href="Discription"> View Source {">>"}</Button>
        </Col>
      </Row> */}
      <Row>
        <Wavesample/>
      </Row>
    </Container>
  );
}
Detailcard.propTypes = {
    imagesrc: PropTypes.any,
    title: PropTypes.string,
    disc: PropTypes.string,
  }
  
export default Detailcard;
